// extracted by mini-css-extract-plugin
var _1 = "HotspotArea_deleteIcon__66136";
var _2 = "HotspotArea_disabled__e1a2c";
var _3 = "HotspotArea_dragging__ed650";
var _4 = "HotspotArea_root__2ea5c";
var _5 = "HotspotArea_selected__208e9";
export { _1 as "deleteIcon", _2 as "disabled", _3 as "dragging", _4 as "root", _5 as "selected" }
